import type { MarkComponent, ParsingOperatorsEnum } from './types';

const otherMarkAbbreviations: Partial<Record<ParsingOperatorsEnum, MarkComponent>> = {
  TK: {
    banner: 'TALENT KEYHOLE',
    portion: 'TK',
  },
  'TK-G': {
    banner: 'TALENT KEYHOLE-GEOCAP',
    portion: 'TK-G',
  },
  'TK-GEOCAP': {
    banner: 'TK-GEOCAP',
    portion: 'TK-G',
  },
  DCNI: {
    banner: 'DOD UNCLASSIFIED CONTROLLED NUCLEAR INFORMATION',
    portion: 'DCNI',
  },
  'REL TO': {
    banner: 'REL TO',
    portion: 'REL',
  },
};

export default otherMarkAbbreviations;
